// extracted by mini-css-extract-plugin
export default {"slide":"Carousel_slide__d+uhB"};